import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import './index.sass';

const { block, el } = bem('cdek-warning-banner-2');
export const CDEKWarningBanner = () => {
    return (
        <div className={ block() }>
            <div className={ el('image') } />
            <div className={ el('content') }>
                <div className={ el('content-wrap') }>
                    <div className={ el('content-top') }>
                        <div className={ el('title') }>
                            <Text serif>{ `Друзья!` }</Text>
                        </div>
                        <div className={ el('description') }>
                            <Text tag={'div'}>{ `Вы можете столкнуться со сложностью оформления доставки в ваш регион из-за технических работ на сайте СДЭК.` }</Text>
                            <Text tag={'div'} >Пожалуйста, оформите заказ с услугой «самовывоз» и <a href="https://wa.me/79851234432" target="_blank">напишите нам здесь.</a></Text>
                            <Text tag={'div'} serif bold>Мы поможем с оформлением доставки в ваш город!</Text>
                        </div>
                    </div>
                    <div className={ el('content-bottom') }>
                        <div className={ el('info') }>
                            <Text>{`Благодарим за понимание.\n
                                Команда «Ответ» ❤️❤️❤️`}</Text>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
